import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	paginationPrev: {
		id: 'inactive-projects-directory-base.projects-table.pagination-prev',
		defaultMessage: 'Prev',
		description: 'Text for going to the previous page in the projects table',
	},
	paginationNext: {
		id: 'inactive-projects-directory-base.projects-table.pagination-next',
		defaultMessage: 'Next',
		description: 'Text for going to the next page in the projects table',
	},
	noData: {
		id: 'inactive-projects-directory-base.projects-table.no-data',
		defaultMessage: 'We couldn’t find any projects that match your search.',
		description: 'Message shown when there are no projects to display',
	},
});
